import React, { useState, useEffect, useRef } from "react";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { ToastContainer, toast } from "react-toastify";
import { BiPhone, BiUser } from "react-icons/bi";
import { motion, AnimatePresence } from "framer-motion";
import { FaSearch, FaFileExcel } from "react-icons/fa";
import { AiOutlineClose } from "react-icons/ai";
import "react-toastify/dist/ReactToastify.css";
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import CustomerForm from "./CustomerForm";
import { BiDialpad } from "react-icons/bi";
import { AiOutlinePlus } from "react-icons/ai";
import DialerPopup from "./DialerPopup";
import ExcelHandler from "./ExcelHandler";
import { FIRST_MESSAGE, CALL_PROMPT } from "../../utils/callConfig";



// import { ToastContainer, toast } from "react-toastify";
const CRM = ({ user }) => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(5);
  const [loadingState, setLoadingState] = useState({});
  const [showCallModal, setShowCallModal] = useState(false);
  const [callStatus, setCallStatus] = useState('calling');
  const [currentContact, setCurrentContact] = useState(null);
  const [callTime, setCallTime] = useState(0);
  const [staticData, setStaticData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDialerOpen, setIsDialerOpen] = useState(false);

  const cancelAutoCallingRef = useRef(false);
  const [isAutoCalling, setIsAutoCalling] = useState(false);
  const [callSettings, setCallSettings] = useState({
    startHour: 8,
    startMinute: 45,
    endHour: 16,
    endMinute: 45
  });
  const [showSettings, setShowSettings] = useState(false);

  const importFileInputRef = useRef(null); // Separate ref for CRM import


  const isAutoCallingRef = useRef(false); // Track state in ref



  useEffect(() => {
    isAutoCallingRef.current = isAutoCalling;
    cancelAutoCallingRef.current = false; // Reset cancellation flag when auto-calling state changes
  }, [isAutoCalling]);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_SERVER_API}/api/settings/calling-hours?userId=${user.id}`)
      .then(response => {
        if (response.data.callSettings) {
          setCallSettings(response.data.callSettings);
          console.log("response.data.callSettings", response.data.callSettings);

        }
      })
      .catch(err => console.error('Error fetching calling hours:', err));
  }, [user.id]);


  useEffect(() => {
    isAutoCallingRef.current = isAutoCalling;
  }, [isAutoCalling]);


// Function to format batchName
const formatBatchName = (batchName) => {
  if (!batchName) return 'N/A';
  // Example batchName: Batch_contacts_2025-04-18T11-11-58
  // Convert to: Batch Contacts 2025-04-18 11:11:58
  const parts = batchName.split('_');
  if (parts.length < 3) return batchName; // Fallback if format is unexpected

  const [prefix, filePart, timestamp] = parts;
  // Replace '-' with ':' in timestamp and 'T' with space
  const formattedTimestamp = timestamp.replace('T', ' ').replace(/-/g, ':');
  return `${prefix} ${filePart} ${formattedTimestamp}`;
};







  const fetchContacts = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${process.env.REACT_APP_SERVER_API}/api/contacts?userId=${user.id}&role=${user.role}`);
      setStaticData(response.data);
      console.log("Fetched contacts:", response.data);

    } catch (error) {
      console.error("Error fetching contacts:", error);
    }
    setIsLoading(false);
  };

  const { handleImportExcel, handleExportExcel } = ExcelHandler({ fetchContacts, user });
  // Fetch contacts from database
  useEffect(() => {

    fetchContacts();
  }, [user]);



  const handleCall = async (contact) => {
    setCurrentContact(contact);
    setShowCallModal(true);
    setCallStatus('calling');
    setLoadingState(prev => ({ ...prev, [contact.id]: true }));
    if (!user) {
      console.error("No user logged in");
      return;
    }
    try {

      const checkResponse = await axios.post(`${process.env.REACT_APP_SERVER_API}/api/check-calling-hours`, {
        phoneNumber: contact.MobileNumber,
        name: contact.name,
        userId: user.id
      });

      if (!checkResponse.data.canCall) {
        toast.warn(`Call to ${contact.name} added to waiting list (outside calling hours)`);
        setCallStatus('waiting');
        setLoadingState(prev => ({ ...prev, [contact.id]: false }));
        await axios.put(`${process.env.REACT_APP_SERVER_API}/api/crm/contact/${contact._id}`, {
          isProcessed: true,
          isConnected: false
        });
        fetchContacts();
        return;
      }
      const response = await axios.post(`${process.env.REACT_APP_SERVER_API}/api/create-call`, {
        toNumber: contact.MobileNumber,
        name: contact.name,
        first_message: FIRST_MESSAGE,
        prompt: CALL_PROMPT,
        userId: user.id,
        role:user
      }, {
        headers: { 'Content-Type': 'application/json' },
      });

      const { callId, callSid } = response.data;
      localStorage.setItem('currentCallSid', callSid);
      localStorage.setItem('currentCallId', callId);
      setCallStatus('connected');
      navigate(`/call/${encodeURIComponent(contact.name)}/${encodeURIComponent(contact.MobileNumber)}`);

      const startTime = Date.now();
      const timer = setInterval(() => {
        setCallTime(Math.floor((Date.now() - startTime) / 1000));
      }, 1000);

      await axios.put(`${process.env.REACT_APP_SERVER_API}/api/crm/contact/${contact._id}`, {
        isProcessed: true,
        isConnected: true
      });


      fetchContacts();
      return true;
    } catch (error) {
      console.error('Call failed:', error);
      setCallStatus('error');
      toast.error("Call failed");
      return false;
    } finally {
      setLoadingState(prev => ({ ...prev, [contact.id]: false }));
    }
  };

  // console.log("DialerPopup Rendered, handleCall crm:", handleCall);


  const formatTime = (seconds) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${String(hrs).padStart(2, '0')}:${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  };


  // Format calling hours for display
  const formatCallingTime = ({ hour, minute }) => {
    const period = hour >= 12 ? 'PM' : 'AM';
    const formattedHour = hour % 12 || 12;
    return `${formattedHour}:${minute.toString().padStart(2, '0')} ${period}`;
  };



  const startAutoCalling = async () => {
    if (isAutoCallingRef.current) {
      toast.warn("Auto-calling is already running");
      return;
    }

    if (!user || !user.id || !user.role) {
      toast.error("User data is missing, cannot start auto-calling");
      return;
    }

    setIsAutoCalling(true);
    isAutoCallingRef.current = true;
    cancelAutoCallingRef.current = false;
    setShowCallModal(true);
    toast.info("Auto-calling started");

    try {
      while (isAutoCallingRef.current) {
        const response = await axios.post(`${process.env.REACT_APP_SERVER_API}/api/auto-call`, {
          userId: user.id,
          role: user.role,
        });

        if (response.data.done) {
          toast.warn(response.data.message || "No unprocessed contacts available");
          break;
        }

        const { contact } = response.data;
        if (!contact || !contact._id || !contact.MobileNumber || !contact.name) {
          toast.error("Invalid contact data, skipping");
          await new Promise((resolve) => setTimeout(resolve, 2000));
          continue;
        }

        setCurrentContact(contact);
        setCallStatus("calling");
        setLoadingState((prev) => ({ ...prev, [contact._id]: true }));
        toast.info(`Calling ${contact.name}...`);

        try {
          const checkResponse = await axios.post(`${process.env.REACT_APP_SERVER_API}/api/check-calling-hours`, {
            phoneNumber: contact.MobileNumber,
            name: contact.name,
            userId: user.id,
          });

          if (!checkResponse.data.canCall) {
            toast.warn(`Call to ${contact.name} added to waiting list (outside calling hours)`);
            setCallStatus("waiting");
            await axios.put(`${process.env.REACT_APP_SERVER_API}/api/crm/contact/${contact._id}`, {
              isProcessed: true,
              isConnected: false,
            });
            fetchContacts();
          } else {
            const callResponse = await axios.post(
              `${process.env.REACT_APP_SERVER_API}/api/create-call`,
              {
                toNumber: contact.MobileNumber,
                name: contact.name,
                first_message: FIRST_MESSAGE,
                prompt: CALL_PROMPT,
                userId: user.id,
              },
              { headers: { "Content-Type": "application/json" } }
            );

            const { callId, callSid } = callResponse.data;
            localStorage.setItem("currentCallSid", callSid);
            localStorage.setItem("currentCallId", callId);

            // Simulate no-answer detection with a timeout
            let isAnswered = false;
            const timeoutPromise = new Promise((resolve) => {
              setTimeout(() => {
                if (!isAnswered) {
                  setCallStatus("no-answer");
                  resolve("no-answer");
                }
              }, 30000); // 30 seconds timeout
            });

            const waitForAnswer = new Promise((resolve) => {
              const checkStatus = setInterval(() => {
                if (callStatus === "connected" || callStatus === "completed") {
                  clearInterval(checkStatus);
                  isAnswered = true;
                  resolve(callStatus);
                }
              }, 500);
            });

            setCallStatus("ringing");
            navigate(`/call/${encodeURIComponent(contact.name)}/${encodeURIComponent(contact.MobileNumber)}`);
            const result = await Promise.race([waitForAnswer, timeoutPromise]);

            if (result === "no-answer") {
              toast.warn(`Call to ${contact.name} not answered`);
              await axios.put(`${process.env.REACT_APP_SERVER_API}/api/crm/contact/${contact._id}`, {
                isProcessed: true,
                isConnected: false,
              });
              await axios.post(`${process.env.REACT_APP_SERVER_API}/api/end-call`, {
                callSid,
                status: "no-answer",
              });
            } else {
              setCallStatus("connected");
              toast.success(`Call to ${contact.name} connected`);
              // navigate(`/call/${encodeURIComponent(contact.name)}/${encodeURIComponent(contact.MobileNumber)}`);
              // Navigate to call page
              try {
                setCallStatus('connected');
                // navigate(`/call/${encodeURIComponent(contact.name)}/${encodeURIComponent(contact.MobileNumber)}`);
                toast.info(`Opening call page for ${contact.name}`);
              } catch (navError) {
                console.error("Navigation error in startAutoCalling:", navError);
                toast.warn("Failed to open call page, but call is connected");
              }

              const startTime = Date.now();
              const timer = setInterval(() => {
                setCallTime(Math.floor((Date.now() - startTime) / 1000));
              }, 1000);

              await axios.put(`${process.env.REACT_APP_SERVER_API}/api/crm/contact/${contact._id}`, {
                isProcessed: true,
                isConnected: true,
              });

              // Wait for completed status
              await new Promise((resolve) => {
                const checkStatus = setInterval(() => {
                  if (callStatus === "completed") {
                    clearInterval(checkStatus);
                    resolve();
                  }
                }, 500);
              });

              clearInterval(timer);
            }
          }
        } catch (error) {
          console.error("Call error for contact:", contact._id, error);
          setCallStatus("error");
          if (error.response?.data?.message?.includes("outside calling hours")) {
            toast.warn(`Call to ${contact.name} added to waiting list (outside calling hours)`);
            setCallStatus("waiting");
          } else {
            toast.error(`Call to ${contact.name} failed: ${error.message}`);
          }
          await axios.put(`${process.env.REACT_APP_SERVER_API}/api/crm/contact/${contact._id}`, {
            isProcessed: true,
            isConnected: false,
          });
          fetchContacts();
        }

        setLoadingState((prev) => ({ ...prev, [contact._id]: false }));

        if (isAutoCallingRef.current) {
          const message =
            callStatus === "completed"
              ? "Call ended"
              : callStatus === "no-answer"
                ? "Call not answered"
                : "Call processed";
          toast.info(`${message}. Preparing next call in 8 seconds...`);
          await new Promise((resolve) => setTimeout(resolve, 10000)); // 8-second delay
        }
      }
    } catch (error) {
      console.error("Auto-calling error:", error);
      toast.error(`Auto-calling stopped: ${error.message}`);
    } finally {
      setIsAutoCalling(false);
      isAutoCallingRef.current = false;
      setShowCallModal(false);
      toast.info("Auto-calling completed");
      localStorage.removeItem("currentCallSid");
      localStorage.removeItem("currentCallId");
    }
  };

  // Stop auto-calling and clean up state
  const stopAutoCalling = async () => {
    cancelAutoCallingRef.current = true;
    setIsAutoCalling(false);
    isAutoCallingRef.current = false;
    setShowCallModal(false);

    
    localStorage.removeItem("currentCallSid");
    localStorage.removeItem("currentCallId");
    setCallStatus("completed");
    setCurrentContact(null);
    setCallTime(0);
    fetchContacts();
    toast.info("Auto-calling stopped");
  };


  // Data filtering and pagination
  const filteredData = Array.isArray(staticData) ? staticData.filter(row =>
    row.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    row.email?.toLowerCase().includes(searchTerm.toLowerCase())
  ) : [];
  const indexOfLastItem = currentPage * itemsPerPage;
  const currentData = filteredData && filteredData.slice(indexOfLastItem - itemsPerPage, indexOfLastItem);
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <motion.div
      className="w-full h-[calc(100vh-4rem)] sm:h-[calc(100vh-5rem)] overflow-y-auto hide-scrollbar p-4 sm:p-6 lg:p-8 bg-gray-50 bg-gray-50 items-center p-8"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
    >
      <div className="max-w-9xl ">
        {/* Header */}
        <div className="bg-gray-50 p-4 mb-6 rounded-xl flex items-center justify-between">
          <h1 className="text-2xl font-bold text-gray-800">Ryngmo CRM</h1>

          <div className="text-gray-600 text-base">
            <span className="font-bold">Calling Hours:</span>{' '}
            <span className="ml-1">
              {formatCallingTime({ hour: callSettings.startHour, minute: callSettings.startMinute })} –{' '}
              {formatCallingTime({ hour: callSettings.endHour, minute: callSettings.endMinute })}
            </span>
          </div>
        </div>

        {/* Search */}
        <div className="flex items-center justify-between mb-6">
          {/* Buttons Section */}
          <div className="flex items-center gap-4">
            <button
              onClick={() => setIsModalOpen(true)}
              className="flex items-center gap-2  text-black px-4 py-2 rounded-sm shadow-md  transition"
            >
              <AiOutlinePlus className="w-5 h-5 text-blue-600" /> Add Customer
            </button>

            <button
              onClick={() => setIsDialerOpen(true)}
              className="flex items-center gap-2  text-black px-4 py-2 rounded-sm shadow-md  transition"
            >
              <BiDialpad className="w-5 h-5 text-blue-600" /> Call Customer
            </button>

            <button
              onClick={() => handleExportExcel(staticData)}
              className="flex items-center gap-2  text-black px-4 py-2 rounded-sm shadow-md transition"
            >
              <FaFileExcel className="w-5 h-5 text-green-500" /> Export to Excel
            </button>

            <div>
              <input
                type="file"
                ref={importFileInputRef}
                accept=".xlsx, .xls"
                onChange={(e) => handleImportExcel(e, user)}
                className="hidden"
                id="excel-import-crm"
              />
              <label
                htmlFor="excel-import-crm"
                className="cursor-pointer flex items-center gap-2  text-black px-4 py-2 rounded-sm shadow-md transition"
              >
                <FaFileExcel className="w-5 h-5 text-green-500" /> Import Data Excel
              </label>
            </div>
          </div>





          <div className="flex items-center gap-4">
            <button
              onClick={startAutoCalling}
              disabled={isAutoCalling}

              className={`flex items-center gap-2 px-4 py-2 rounded-sm shadow-md transition ${isAutoCalling ? 'bg-gray-400' : 'bg-green-500 text-white hover:bg-green-600'}`}
            >
              <BiPhone className="w-5 h-5" /> Start Calling
            </button>
            <button
              onClick={stopAutoCalling}
              // disabled={!isAutoCalling}
              className={`flex items-center gap-2 px-4 py-2 rounded-sm shadow-md transition ${!isAutoCalling ? 'bg-gray-400' : 'bg-red-500 text-white hover:bg-red-600'}`}
            >
              <AiOutlineClose className="w-5 h-5" /> Stop Calling
            </button>
            <div className="relative w-64">
              <FaSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-500" />
              <input
                type="text"
                placeholder="Search by name or email"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full bg-white border border-gray-300 rounded-lg pl-12 pr-8 py-2 shadow-md"
              />
              {searchTerm && (
                <AiOutlineClose
                  onClick={() => setSearchTerm("")}
                  className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 cursor-pointer"
                />
              )}
            </div>
          </div>
        </div>
        {isLoading && (
          <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-50 animate-pulse">
            <AiOutlineLoading3Quarters
              className="animate-spin text-white"
              size={48}
            />
          </div>
        )}
        {/* Contacts Table */}
        <div className="bg-white rounded-lg shadow ">
          <table className=" w-full  divide-y divide-gray-200">
            <thead className="bg-blue-400 text-white">
              <tr>
                {["Sr", "Name", "Phone", "Location", "Email",'Batch Name' , "Actions"].map((header) => (
                  <th key={header} className="px-4 py-3 text-md font-semibold text-center">
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="  bg-white divide-y divide-gray-200">
              {currentData && currentData.length > 0 ? (
                currentData.map((row, index) => {
                  const autoIncrementId = (currentPage - 1) * itemsPerPage + index + 1;
                  return (
                    <tr key={autoIncrementId} className="hover:bg-gray-100 transition-all">
                      <td className="px-4 py-3 text-md text-center truncate">{autoIncrementId}</td>
                      <td className="px-4 py-3 text-md text-center truncate">{row.name}</td>
                      <td className="px-4 py-3 text-md text-center truncate">{row.MobileNumber}</td>
                      <td className="px-4 py-3 text-md text-center truncate">{row.location}</td>
                      <td className="px-4 py-3 text-md text-center truncate">{row.email}</td>
                      <td className="px-4 py-3 text-md text-center truncate">{formatBatchName(row.batchName)}</td>
                      <td className="px-4 py-3 text-md text-center">
                        <button
                          onClick={() => handleCall(row)}
                          className="text-blue-600 hover:text-blue-800 disabled:opacity-50"
                          disabled={loadingState[row.id || row.MobileNumber]}
                        >
                          {loadingState[row.id || row.MobileNumber] ? (
                            <AiOutlineLoading3Quarters className="animate-spin h-6 w-6" />
                          ) : (
                            <BiPhone className="h-6 w-6" />
                          )}
                        </button>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="6" className="text-center py-8 text-gray-500">
                    No contacts data found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {/* Pagination */}
        <div className="flex justify-center mt-8 space-x-2">
          <button
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
            className="px-4 py-2 bg-gray-200 rounded-md disabled:opacity-50 hover:bg-gray-300"
          >
            Previous
          </button>
          {Array.from({ length: totalPages }, (_, idx) => (
            <button
              key={idx}
              onClick={() => paginate(idx + 1)}
              className={`px-4 py-2 rounded-md ${currentPage === idx + 1 ? 'bg-blue-400 text-white' : 'bg-gray-200 hover:bg-gray-300'
                }`}
            >
              {idx + 1}
            </button>
          ))}
          <button
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="px-4 py-2 bg-gray-200 rounded-md disabled:opacity-50 hover:bg-gray-300"
          >
            Next
          </button>
        </div>
        {/* Call Modal */}
        <AnimatePresence>
          {showCallModal && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4"
            >
              <motion.div
                initial={{ scale: 0.9 }}
                animate={{ scale: 1 }}
                className="bg-white rounded-xl p-8 max-w-md w-full"
              >
                <div className="text-center space-y-4">
                  {/* Profile Icon */}
                  <div className="w-20 h-20 bg-gray-100 rounded-full mx-auto flex items-center justify-center">
                    <BiUser className="w-12 h-12 text-gray-500" />
                  </div>

                  {/* Contact Info */}
                  <h3 className="text-xl font-semibold">{currentContact?.name}</h3>
                  <p className="text-gray-600">{currentContact?.MobileNumber}</p>

                  {/* Call Status */}
                  <div className="text-lg font-medium text-gray-700">
                    {callStatus === 'calling' && (
                      <div className="flex items-center justify-center space-x-2">
                        <span>Calling...</span>
                        <div className="flex space-x-1">
                          <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce" />
                          <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce delay-100" />
                          <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce delay-200" />
                        </div>
                      </div>
                    )}
                    {callStatus === 'connected' && formatTime(callTime)}
                    {callStatus === 'error' && 'Call Failed'}
                  </div>

                  {/* Action Buttons */}
                  <button
                    onClick={() => {
                      setShowCallModal(false);
                      window.close();
                    }}
                    className="w-full bg-red-600 text-white py-3 rounded-full hover:bg-red-700 transition-colors"
                  >
                    {callStatus === 'error' ? 'Close' : 'End Call'}
                  </button>
                </div>
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>
        <DialerPopup isOpen={isDialerOpen} onClose={() => setIsDialerOpen(false)} user={user} ></DialerPopup>
        <CustomerForm isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} fetchContacts={fetchContacts} handleCall={handleCall} user={user} />
      </div>
      <ToastContainer position="top-right" autoClose={3000} />
    </motion.div>
  );
};

export default CRM;